var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clearfix" }, [
    _c(
      "div",
      {
        ref: "reassignSubmissionModal",
        staticClass: "reveal reassign-submission-modal",
        attrs: { id: "reassignSubmissionModal", "data-reveal": "" },
      },
      [
        _c("div", { staticClass: "tender-confirm clearfix" }, [
          _c(
            "div",
            {
              class: {
                "required-error-highlight":
                  _vm.inputRequireHighlight && !_vm.newPersonInCharge,
              },
            },
            [
              _c("label", { staticClass: "reassign-submission-title" }, [
                _vm._v(_vm._s(_vm.$t("action.reAssignTo"))),
              ]),
              _vm._v(" "),
              _c("HKLSelect", {
                staticClass: "next-design-reviewer-selector",
                attrs: {
                  value: _vm.newPersonInChargeId || undefined,
                  options: _vm.reviewerHklOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.onReviewerChange },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row align-right nav_btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              attrs: { id: "confirm_no", type: "button", "data-close": "" },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { id: "confirm_ok", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.changeAssignee()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.ok")))]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }